export default class DtoStaffSafety {
    constructor(obj) {
        this.idStation = obj.idStation
        this.code = obj.code
        this.isIntegrated = obj.isIntegrated
        this.comment = obj.comment
    }
}